import {inject, Service, signal} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';

@Service()
export class LayoutService {
    private readonly breakpointObserver = inject(BreakpointObserver);

    public readonly isMobile = signal(false);
    public readonly isMenuVisibleMobile = signal(false);
    public readonly sidePanelCollapsed = signal(false);
    /** Écran trop étroit pour des zones côte à côte : elles s'empilent alors sur toute la largeur. */
    public readonly isNarrow = signal(false);

    public constructor() {
        this.breakpointObserver.observe('(max-width: 812px)').subscribe((result) => {
            this.isMobile.set(result.matches);
        });

        this.breakpointObserver.observe('(max-width: 999px)').subscribe((result) => {
            this.isNarrow.set(result.matches);
        });

        this.breakpointObserver.observe('(max-width: 1279px)').subscribe((result) => {
            this.sidePanelCollapsed.set(result.matches);
        });
    }

    public toggleMenu = (): void => this.sidePanelCollapsed.set(!this.sidePanelCollapsed());

    public collapseMenu = (): void => this.sidePanelCollapsed.set(true);

    public uncollapseMenu = (): void => this.sidePanelCollapsed.set(false);

    public openMenuMobile = (): void => this.isMenuVisibleMobile.set(true);

    public closeMenuMobile = (): void => this.isMenuVisibleMobile.set(false);
}
